module.exports = __webpack_public_path__ + "img/tokyo-sauna-collapse.2ad2f1a1.png";